import { useEffect, useState } from "react";
import { animateNumber, formatEuro, formatNumber } from "./numbers";

interface Props {
  value: number;
  format?: "plain" | "euro";
}

export function AnimatedNumber({ value, format = "plain" }: Props) {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    return animateNumber(value, setCurrent);
  }, [value]);
  return <>{format === "euro" ? formatEuro(current) : formatNumber(current)}</>;
}
